"use strict";
// eslint-disable-next-line no-extend-native
Array.prototype.filterNil = function () {
    return this.filter(i => i !== null && i !== undefined);
};
//# sourceMappingURL=filterNil.js.map